
                import "css-modules://src_components_spacer"
                export default {"Main":"_8576d3","Small":"_ccbbc1"}
            